export const jwtTokenName = process.env.VUE_APP_COOKIE_NAME || 'jwtToken'
export const refreshJwtTokenName = jwtTokenName + '_refresh'
export const refreshUserName = process.env.VUE_APP_COOKIE_REFRESH_NAME || 'force_user_me_refresh'

export enum SpaName {
    LECLUB = 'leclub',
    LENETWORK = 'lenetwork',
}
